import * as z from "zod/v4";

const DisplayMessageItem_ = z.object({
  type: z.literal("message"),
  role: z.enum(["user", "assistant"]),
  content: z.string(),
  fileNames: z.array(z.string()).optional(),
});

const DisplayToolCallStatusItem_ = z.object({
  type: z.literal("tool-call-status"),
  toolCallId: z.string(),
  toolName: z.string(),
  input: z.unknown(),
  isComplete: z.literal(true),
});

const DisplayAskUserQuestionItem_ = z.object({
  type: z.literal("ask-user-question"),
  toolCallId: z.string(),
  input: z.object({
    questionType: z.enum(["singleSelect", "multiSelect"]),
    question: z.string(),
    questionContext: z.string().nullable().optional(),
    answerOptions: z.array(
      z.object({
        optionTitle: z.string(),
        optionDescription: z.string().nullable().optional(),
      }),
    ),
  }),
  responded: z.boolean().optional(),
  response: z
    .object({
      selectedOptions: z.array(z.string()).optional(),
      otherText: z.string().optional(),
    })
    .optional(),
});

const DisplayUserConfirmationItem_ = z.object({
  type: z.literal("user-confirmation"),
  toolCallId: z.string(),
  rejected: z.boolean(),
});

const DisplayCompletedOperationItem_ = z.object({
  type: z.literal("completed-operation"),
  operationType: z.enum([
    "create",
    "update",
    "delete",
    "link_suppliers",
    "create_supplier",
    "update_supplier",
    "create_bom",
    "update_bom",
    "create_location",
    "set_product_locations",
    "create_purchase_order",
    "update_purchase_order",
    "adjust_inventory",
  ]),
  productCount: z.number().optional(),
  supplierCount: z.number().optional(),
  bomCount: z.number().optional(),
  locationCount: z.number().optional(),
  purchaseOrderCount: z.number().optional(),
  linksUpdated: z.number().optional(),
  fields: z.array(z.string()).optional(),
  toolCallId: z.string().optional(),
  isUndone: z.boolean().optional(),
  adjustmentSessionKind: z.string().optional(),
});

export const DisplayItemSchema = z.discriminatedUnion("type", [
  DisplayMessageItem_,
  DisplayToolCallStatusItem_,
  DisplayCompletedOperationItem_,
  DisplayAskUserQuestionItem_,
  DisplayUserConfirmationItem_,
]);
export type DisplayItem = z.infer<typeof DisplayItemSchema>;

export const getCatalogAgentThreadMessages = {
  name: "getCatalogAgentThreadMessages" as const,
  input: z.object({ threadId: z.string() }),
  output: z.object({
    threadId: z.string(),
    items: z.array(DisplayItemSchema),
    pendingConfirmations: z.array(
      z.object({
        toolCallId: z.string(),
        toolName: z.string(),
        confirmationData: z.unknown(),
        confirmationPrompt: z.string(),
      }),
    ),
  }),
};
